import { render, staticRenderFns } from "./LayoffForm.vue?vue&type=template&id=0bc930c0"
import script from "./LayoffForm.vue?vue&type=script&lang=js"
export * from "./LayoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports